import { useQueryGetSubProgramPreferenceInfo } from 'api/queries/getSubProgramPreferenceInfo.query';

import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { AliasPreferences } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/AliasPreferences/aliasPreferences';
import { ExcelExport } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/ExcelExport/ExcelExport';
import { ImportantActivities } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/ImportantActivities/ImportantActivities';
import { OverdueAndUrgentDateThreshold } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/OverdueAndUrgentDateThreshold/overdueAndUrgentDateThreshold';
import { TagList } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/TagList/tagList';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/components/subProgramPreferences.module.scss';
import { ProgressMeasurement } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/progressMeasurement/progressMeasurement';

export const SubProgramPreferences = () => {
    const { data } = useQueryGetSubProgramPreferenceInfo();

    return (
        <>
            <WidgetWithTitle title={'Sub Program Preferences'} tooltip={data}>
                <div className={classes.formContainer}>
                    <p className={classes.note}>
                        You will be prompted to confirm in case you make any changes to the sub program preferences.
                    </p>
                    <div className={classes.inputWrapper}>
                        <TagList />
                    </div>
                    <div className={classes.inputWrapper}>
                        <ProgressMeasurement />
                    </div>

                    <div className={classes.inputWrapper}>
                        <OverdueAndUrgentDateThreshold />
                    </div>
                    <div className={classes.inputWrapper}>
                        <ImportantActivities />
                    </div>
                    <div className={classes.inputWrapper}>
                        <ExcelExport />
                    </div>
                </div>
            </WidgetWithTitle>

            <AliasPreferences />
        </>
    );
};
